import type { HelpFile } from '../../types/help'
import { FunctionGroupDetailTestIds } from '../../../testids/FunctionGroupDetailTestIds'

export const functionGroupDetailHelp: HelpFile = {
  docPage: '/docs/access/role-assignments',
  texts: {
    [FunctionGroupDetailTestIds.functionGroupDetailPage]:
      'Detailansicht einer Funktionsgruppe — ihre Zugriffsprofile, Attribute und die Identitäten, die davon erben.',
    [FunctionGroupDetailTestIds.fgAccessProfilesCard]:
      'Direkt dieser Funktionsgruppe zugeordnete Zugriffsprofile. Identitäten, die dieser Funktionsgruppe (und ihren Untergruppen) zugewiesen sind, erben diese Zugriffsprofile.',
    [FunctionGroupDetailTestIds.apEmptyState]:
      'Mit dieser Funktionsgruppe sind keine Zugriffsprofile verknüpft. Fügen Sie eines hinzu, um zugewiesenen Identitäten Zugriff zu gewähren.',
    [FunctionGroupDetailTestIds.apWarning100]:
      'Diese Funktionsgruppe ist mit mehr als 100 Zugriffsprofilen verknüpft. Eine Aufteilung sorgt für klarere Governance.',
    [FunctionGroupDetailTestIds.btnRetryAp]:
      'Lädt die Zugriffsprofile nach einem temporären Fehler erneut.',
    [FunctionGroupDetailTestIds.cardFunctionGroupDetails]:
      'Kernattribute der Funktionsgruppe — Name, Code, Beschreibung und Status im Lebenszyklus.',
    [FunctionGroupDetailTestIds.cardTitleAttributes]:
      'Für diese Funktionsgruppe erfasste benutzerdefinierte Attribute gemäß dem Schema Ihres Tenants.',
    [FunctionGroupDetailTestIds.colCode]:
      'Stabiler maschinenlesbarer Code des Zugriffsprofils.',
    [FunctionGroupDetailTestIds.colEnvironment]:
      'Zielumgebung (Produktion, Test, Entwicklung), auf die das Zugriffsprofil angewendet wird.',
    [FunctionGroupDetailTestIds.colName]: null,
    [FunctionGroupDetailTestIds.colResource]:
      'Ressource auf dem Zielsystem, auf die das Zugriffsprofil Zugriff gewährt.',
    [FunctionGroupDetailTestIds.colRiskLevel]:
      'Risikoklassifizierung des Zugriffsprofils (niedrig, mittel, hoch, kritisch).',
    [FunctionGroupDetailTestIds.colStatus]:
      'Status im Lebenszyklus des Zugriffsprofils — aktiv, veraltet oder zurückgezogen.',
  },
}
